import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { isArrayLike } from 'mobx';
import isPlainObject from 'lodash/isPlainObject';
import isNil from 'lodash/isNil';
import { FormField } from '../field/FormField';
import autobind from '../_util/autobind';
import { Tooltip as TextTooltip } from '../core/enum';
import { processFieldValue, renderMultiLine, toRangeValue } from '../field/utils';
import isEmpty from '../_util/isEmpty';
import isOverflow from '../overflow-tip/util';
import { show } from '../tooltip/singleton';
import { defaultOutputRenderer } from './utils';
let Output = class Output extends FormField {
    isEditable() {
        return false;
    }
    useFocusedClassName() {
        return false;
    }
    handleChange() {
        // noop
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'name',
            'renderEmpty',
        ]);
    }
    getOtherPropsExcludeOutput(otherProps) {
        return otherProps;
    }
    getWrapperClassNamesExcludeOutput() {
        return undefined;
    }
    getObservablePropsExcludeOutput() {
        return undefined;
    }
    getValueKey(value) {
        if (isArrayLike(value)) {
            return value.map(this.getValueKey, this).join(',');
        }
        return this.processValue(value);
    }
    processValue(value) {
        if (!isNil(value)) {
            const text = isPlainObject(value) ? value : super.processValue(value);
            const { field } = this;
            return processFieldValue(text, field, {
                getProp: (name) => this.getProp(name),
                getValue: () => this.getValue(),
                lang: this.lang,
                getDisplayProp: (name) => this.getDisplayProp(name),
            }, true, this.record, this.getContextConfig);
        }
        return '';
    }
    defaultRenderer(renderProps) {
        return defaultOutputRenderer(renderProps);
    }
    /**
     * 多行单元格渲染
     */
    renderMultiLine(field) {
        const { name, record, dataSet, prefixCls, props: { renderer }, } = this;
        const { lines, multipleValidateMessageLength } = renderMultiLine({
            name,
            field,
            record,
            dataSet,
            prefixCls,
            renderer,
            renderValidationResult: this.renderValidationResult,
            isValidationMessageHidden: this.isValidationMessageHidden,
            processValue: this.processValue.bind(this),
            tooltip: this.props.tooltip,
            labelTooltip: this.labelTooltip,
        });
        this.multipleValidateMessageLength = multipleValidateMessageLength;
        return lines;
    }
    getRenderedValue() {
        if (this.multiple) {
            const { tags } = this.renderMultipleValues(true);
            return tags;
        }
        if (this.range) {
            return this.renderRangeValue(toRangeValue(this.getValue(), this.range));
        }
        /**
         * 多行单元格渲染
         */
        const { field } = this;
        if (field && field.get('multiLine', this.record)) {
            return this.renderMultiLine(field);
        }
        return this.processRenderer(this.getValue());
    }
    showTooltip(e) {
        if (super.showTooltip(e)) {
            return true;
        }
        const { getTooltip, getTooltipTheme, getTooltipPlacement } = this.context;
        const { tooltip = getTooltip('output') } = this.props;
        const { element, field } = this;
        const { isOverflowMaxTagCount } = this.renderMultipleValues(true);
        const title = this.multiple ? this.processRenderer(this.getValue()) : this.getRenderedValue();
        const placement = getTooltipPlacement('output') || 'right';
        const theme = getTooltipTheme('output');
        if (this.multiple && title && isOverflowMaxTagCount) {
            show(element, { title, placement, theme });
            return true;
        }
        if (element && !(field && field.get('multiLine', this.record)) && (tooltip === TextTooltip.always || (tooltip === TextTooltip.overflow && isOverflow(element)))) {
            if (title) {
                show(element, { title, placement, theme });
                return true;
            }
        }
        return false;
    }
    renderWrapper() {
        const result = this.getRenderedValue();
        const { renderEmpty } = this.props;
        const text = isEmpty(result) || (isArrayLike(result) && !result.length) ? renderEmpty ? renderEmpty() : this.getContextConfig('renderEmpty')('Output') : result;
        const floatLabel = this.renderFloatLabel();
        return floatLabel ? (React.createElement("span", Object.assign({}, this.getWrapperProps()),
            floatLabel,
            React.createElement("span", Object.assign({}, this.getOtherProps()), text))) : React.createElement("span", Object.assign({}, this.getMergedProps()), text);
    }
};
Output.displayName = 'Output';
// eslint-disable-next-line camelcase
Output.__PRO_OUTPUT = true;
Output.defaultProps = {
    ...FormField.defaultProps,
    suffixCls: 'output',
};
__decorate([
    autobind
], Output.prototype, "handleChange", null);
__decorate([
    autobind
], Output.prototype, "getValueKey", null);
__decorate([
    autobind
], Output.prototype, "defaultRenderer", null);
Output = __decorate([
    observer
], Output);
export default Output;
